import { getPluralForm } from './getPluralForm';

interface IOptions {
  pluralLabel?: string,
  includeCount?: boolean;
}

/**
 * Returns the count and the label with a postfix 's' if
 * the count is plural, if singular, will return
 * the original label.
 *
 * @param count count to be checked
 * @param label label for the count
 * @param pluralLabel label to override the plural form
 * @param options additional options
 */
export const formatCountLabel = (
  count: number,
  label: string,
  options?: IOptions,
) => {
  const hasCount = options?.includeCount ?? true;
  const pluralForm = options?.pluralLabel ?? getPluralForm(label);

  return `${hasCount ? `${count} ` : ''}${count !== 1 ? pluralForm : label}`;
};
